import { RequestMethods, IFetchResult } from 'networking/fetchConfig';
import { SpacemanFee } from 'types/spacemanTypes';
import { spacemanFetch } from 'networking/spaceman/spacemanFetch';

export function getLocationFees(locationUuid: string): Promise<IFetchResult<SpacemanFee[]>> {
  return spacemanFetch<SpacemanFee[]>(RequestMethods.GET, `/api/locations/${locationUuid}/fees`);
}
